import * as React from "react";
import { StyledStep } from "../../../../components/ReactTourSteps/ReactTourSteps.styles";

export const tourSteps = [
  {
    selector: ".step-1",
    content: () => (
      <StyledStep>
        <h1 className="step-title">Performance Learning Score &amp; Profile</h1>
        <p className="step-text">
          Here I show you the Performance Learning Results for one individual. You'll see their
          Performance Learning score in the circle and a description of their Performance Learning Trait.
        </p>
      </StyledStep>
    ),
    style: { background: "#2a2a2a" },
  },
  {
    selector: ".step-2",
    content: () => (
      <StyledStep>
        <h1 className="step-title">Perceptions</h1>
        <p className="step-text">
          Click here and I will show you what Perception areas the selected
          individual may need help with. Perceptions range from needing No
          Attention to Urgent Attention Needed.
        </p>
      </StyledStep>
    ),
    style: { background: "#2a2a2a" },
  },
  {
    selector: ".step-3",
    content: () => (
      <StyledStep>
        <h1 className="step-title">Responses</h1>
        <p className="step-text">
          Here I'll show you all of the answers an individual selected in their
          Performance Learning Assessment.
        </p>
      </StyledStep>
    ),
    style: {
      background: "#2a2a2a",
    },
  },
  {
    selector: ".step-4",
    content: () => (
      <StyledStep>
        <h1 className="step-title">Download Report</h1>
        <p className="step-text">
          If you are looking for an overview of just one individual here is the
          place to do it. Click download and I'll generate you a short one-page
          overview of their Performance Learning Assessment results.
        </p>
      </StyledStep>
    ),
    style: {
      background: "#2a2a2a",
    },
  },
];



// WEBPACK FOOTER //
// ./src/pages/DataCenter/School/ViewStudentData/ViewStudentDataTour.tsx